import { type MessageGroup } from '@/features/messaging/ConversationViewModel'
import { type MessageViewModel } from '@/features/messaging/MessageViewModel'
import {
  type MessageEditProps,
  type MessageSender,
} from '@/features/messaging/components/ConversationView/Messages/List/MessageGroup'

/**
 * Edit bindings shared by the list and bubble layouts.
 */
export function messageEditProps(message: MessageViewModel): MessageEditProps {
  return {
    allowEdit: message.canEdit,
    isEditing: message.isEditing,
    text: message.message.text,
    isSavePending: message.isSavePending,
    onStartEdit: message.startEdit,
    onSave: message.saveEdit,
    onCancel: message.cancelEdit,
  }
}

/**
 * Sender bindings shared by the list and bubble layouts.
 */
export function messageSender(group: MessageGroup): MessageSender {
  return {
    avatar: group.sender,
    online: group.sender.user.online,
    isCurrentUser: group.sender.isCurrentUser,
    displayName: group.sender.displayName,
  }
}
